<template>
    <div class="container">
        <h1 class="lead">
        SPA dengan VueJS dan Laravel API
        </h1>
        <img src="@/assets/design.svg" class="d-flex justify-content-star" />
    </div>
</template>
<script>
export default {};
</script>

<style scoped>
h1 {font-size:1.5rem;} /*1rem = 16px*/
@media (min-width: 544px) {  
  h1 {font-size:2rem;} /*1rem = 16px*/
}
 
/* Medium devices (tablets, 768px and up) The navbar toggle appears at this breakpoint */
@media (min-width: 768px) {  
  h1 {font-size:2rem;} /*1rem = 16px*/
}
 
/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) { 
  h1 {font-size:3rem;} /*1rem = 16px*/
}
 
/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {  
  h1 {font-size:4rem;} /*1rem = 16px*/    
}

 /* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {img {width: 60%;}}

/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {img {width: 60%;}}

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {img {width: 60%;}}
/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {img {width: 50%;}}
</style>
